// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2PUSE","errorLogs":"EditorFooter_errorLogs__2tHnT"};